import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field } from '@common/encoding';
import { RecordCategory } from '../members/records/RecordCategory.js';
import { CustomerFieldRequirement } from './CustomerFieldRequirement.js';
export const customerFieldKeys = ['name', 'email', 'phone', 'birthDay', 'gender', 'address'];
/**
 * Which details are collected from a person.
 */
export class CustomerSettings extends AutoEncoder {
    name = CustomerFieldRequirement.Required;
    email = CustomerFieldRequirement.Disabled;
    phone = CustomerFieldRequirement.Disabled;
    birthDay = CustomerFieldRequirement.Disabled;
    gender = CustomerFieldRequirement.Disabled;
    address = CustomerFieldRequirement.Disabled;
    /**
     * Extra questions, listed inline with the customer inputs
     */
    recordCategory = null;
}
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "name", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "email", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "phone", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "birthDay", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "gender", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerFieldRequirement) })
], CustomerSettings.prototype, "address", void 0);
__decorate([
    field({ decoder: RecordCategory, nullable: true })
], CustomerSettings.prototype, "recordCategory", void 0);
//# sourceMappingURL=CustomerSettings.js.map